function get(state) {
    return state.settings;
}

export function isRealtimeEnabled(state) {
    return get(state).realtimeEnabled;
}

export function isSoundEnabled(state) {
    return get(state).soundEnabled;
}
